'use client';

export { productCardsQueryOptions } from './api/product-queries';
